module.exports = __webpack_public_path__ + "media/icons/heart-c9392373.svg";